<script>
import { CarouselItem } from 'element-ui';
const CarouselItemWrapper = CarouselItem;
export default CarouselItemWrapper;
</script>

<style lang="scss" src="../../theme/carousel-item.scss"></style>
